import { AbyssTheme as themeConfiguration } from '@src/app/browser';
import { AnalyzeRisksButton } from '@src/features/RiskAnalysis/components/buttons/AnalyzeRisks';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Divider } from '@uhg-abyss/web/ui/Divider';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import React from 'react';

import { ExportSharePoint } from './components/ExportSharePoint';
import { ViewSharePoint } from './components/ViewSharePoint';

/**
 * Header
 *
 * @TODO Needs description.
 *
 * @param allowExport
 * @param criteria
 * @param currentEntity
 * @param exportDetails
 * @param exportRefetch
 * @param pollingRate
 * @param riskRecordCount
 * @param setPollingRate
 * @param showAnalyzeRisks
 * @returns {Element}
 * @constructor
 */
export function Header({
  allowExport = false,
  criteria = {
    entrance: {
      additional: [],
    },
  },
  currentEntity = {
    id: '',
    name: '',
  },
  exportDetails = {
    exportColumns: [],
    exportDescription: '',
    exportFilters: [],
    exportName: '',
    exportType: '',
  },
  exportRefetch = () => {},
  pollingRate = 0,
  riskRecordCount = 0,
  setPollingRate = () => {},
  showAnalyzeRisks = false,
}) {
  return (
    <ErrorHandler location="src/entities/RiskRecord/ui/components/tables/RiskRecords/components/Header/Header.jsx">
      <Layout.Group
        alignItems="bottom"
        alignLayout="left"
        css={{ height: '100%' }}
        space={Number(themeConfiguration?.theme?.space?.sm) || 8}
      >
        <Flex alignItems="top">
          {allowExport === true && [
            <div key="exportSharePoint">
              <ExportSharePoint
                currentEntity={currentEntity}
                exportDetails={exportDetails}
                exportRefetch={exportRefetch}
                pollingRate={pollingRate}
                riskRecordCount={riskRecordCount}
                setPollingRate={setPollingRate}
              />
            </div>,
            <div key="divider">
              <Divider height={24} orientation="vertical" width={1} />
            </div>,
          ]}

          {allowExport === true && (
            <div>
              <ViewSharePoint currentEntity={currentEntity} exportDetails={exportDetails} />
            </div>
          )}

          {allowExport === true && showAnalyzeRisks && (
            <div>
              <Divider height={24} orientation="vertical" width={1} />
            </div>
          )}

          {showAnalyzeRisks === true && (
            <div>
              <AnalyzeRisksButton criteria={criteria} variant="link" />
            </div>
          )}
        </Flex>
      </Layout.Group>
    </ErrorHandler>
  );
}
